import { render, staticRenderFns } from "./MrTemplate.vue?vue&type=template&id=03bdd712&"
import script from "./MrTemplate.vue?vue&type=script&lang=js&"
export * from "./MrTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports